export enum EnumStatusOferta {
    "o" = "oferta primita",
    "a" = "anulata",
    "p" = "cerere trimisa"
}
